import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { ErroAoCarregar, tentarDeNovoAoCarregar } from "../ErroAoCarregar";

import { CampanhasView } from "./CampanhasView";
import { ICampanhaResumo } from "./types";

export interface ICResponse {
  campaignDates: {
    campaignCommunicationType: ("email" | "whatsapp")[]
    campaignStartDate: string | null;
    campaignEndDate: string | null;
    lastUpdateDate: string | null;
  };
  dataResumo: ICampanhaResumo;

  connectors: [];
  data: {
    nome: string;
    taxPayerId: string;
    parentType: "dependent" | "employee";
    // campaignType: ???? (I will validate if it returns or not)
    dateSend: Date | null;
    dateOpen: Date | null;
    dateDone: Date | null;
    status: "pending" | "done";
    campaignLink: string;
  }[];
}

export function View() {
  const { workspaceActivityId } = useParams() as {
    workspaceActivityId: string;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["campanhas", workspaceActivityId],
    queryFn: () => api.get(`/missing-data/campaigns/${workspaceActivityId}`),
    select: (data) => data.data.data as ICResponse,
    retry: tentarDeNovoAoCarregar,
    // refetchInterval: 5000
  });

  return (
    <>
      {isLoading && <div>Carregando...</div>}
      {isError && <ErroAoCarregar error={error} />}
      {data && <CampanhasView dates={data.campaignDates} resumo={data.dataResumo} />}
    </>
  );
}
